module.exports = __webpack_public_path__ + "img/methodRed.a84e654e.jpg";